import React from 'react';
import { Tooltip } from 'antd';

const TextWithTooltip = ({ text, maxWidth, isOverflowing, className, onClick = (e) => {} }) => {
  return (
    <div style={{ maxWidth, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {isOverflowing ? (
        <Tooltip title={text}>
          <span className={className} onClick={onClick}>
            {text}
          </span>
        </Tooltip>
      ) : (
        <span className={className} onClick={onClick}>
          {text}
        </span>
      )}
    </div>
  );
};

export default TextWithTooltip;
